import { useEffect, useRef } from 'react';
import { scTrack } from '@web3/base-tracking';
import { useHybirdWallet } from '@web3/base-hooks';
import { getSearchParams } from '@web3/base-utils';
import { Event, Page } from '@/config/track-config';

import { Banner } from './Banner';
import PrizePool from './PrizePool';
import StepLine from './StepLine';
import FAQ from './FAQ';
import TAC from './TAC';
import Projects from './Projects';
import { useHomeData } from '@/hooks/home';

import styles from './style.module.scss';
import JudgesList from './JudgesList';

export const HomePage = () => {
  const { walletId, walletType, walletIsReady } = useHybirdWallet();
  const { homeData, init, activeStatus, showEarn } = useHomeData();
  const searchParams = getSearchParams() as { activityCode?: string };
  const timer = useRef(null);

  useEffect(() => {
    if (!walletIsReady) return;
    init({
      walletId,
      walletType,
      activityCode: searchParams?.activityCode,
    });
  }, [walletId, walletType, walletIsReady]);

  useEffect(() => {
    // -> startTime 刷新
    if (!homeData?.startTime) return;
    const currentTime = Date.now();
    const timeDiff = homeData.startTime - currentTime;
    if (timeDiff > 0) {
      timer.current = setTimeout(() => {
        clearTimeout(timer.current);
        init({
          walletId,
          walletType,
          activityCode: searchParams?.activityCode,
        });
      }, timeDiff);
    }
    return () => {
      clearTimeout(timer.current);
    };
  }, [homeData]);

  useEffect(() => {
    scTrack(Event.Web3PageView, {
      page_name: Page.HomePage,
    });
  }, []);

  return (
    <div className={styles.container}>
      <Banner homeData={homeData} />
      <div className={styles.wrapper}>
        <PrizePool />
        {!homeData?.isVoted && <StepLine activeStatus={activeStatus} />}
        <Projects homeData={homeData} activeStatus={activeStatus} />
        {homeData?.isVoted && <StepLine activeStatus={activeStatus} />}
        <JudgesList />
        <FAQ />
        <TAC />
      </div>
    </div>
  );
};
